import { render, staticRenderFns } from "./parcs.vue?vue&type=template&id=a06f6db6&scoped=true"
import script from "./parcs.vue?vue&type=script&lang=js"
export * from "./parcs.vue?vue&type=script&lang=js"
import style0 from "./parcs.vue?vue&type=style&index=0&id=a06f6db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06f6db6",
  null
  
)

export default component.exports